module.exports = __webpack_public_path__ + "static/media/faster.a02314df.svg";